export default "__VITE_ASSET__7d5a8122__"